import React from "react";

export default function SkipLink() {
  return (
    <a href="#main-content" className="skip-link" data-testid="skip-link">
      Skip to main content
    </a>
  );
}
